// extracted by mini-css-extract-plugin
export default {"tags":"tags__UluIqo","tagsList":"tagsList__VyMVT_","allTags":"allTags__Kx4qre","checkboxes":"checkboxes__sORLhm","buttons":"buttons__iZ55E4"};